var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.7071 4.70711C26.0976 4.31658 26.0976 3.68342 25.7071 3.29289L19.3431 -3.07107C18.9526 -3.46159 18.3195 -3.46159 17.9289 -3.07107C17.5384 -2.68054 17.5384 -2.04738 17.9289 -1.65685L23.5858 4L17.9289 9.65685C17.5384 10.0474 17.5384 10.6805 17.9289 11.0711C18.3195 11.4616 18.9526 11.4616 19.3431 11.0711L25.7071 4.70711ZM0 5H25V3H0L0 5Z","fill":"#3D3636"}));
}

ArrowRight.defaultProps = {"width":"26","height":"8","viewBox":"0 0 26 8","fill":"none"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
